module.exports = __webpack_public_path__ + "media/3x/3-370183bb.png";